import { Routes, Route } from "react-router-dom";
import AppHandoff from "../app-handoff/main";
import PreviewInsole from "../preview-insole/Main";
import Personalization from "../personilzation/Main";
import { AppHandoffRoute, PersonalizationRoute, PreviewInsoleRoute, ScanInProgressRoute } from "../../constants/routes";
import WithActiveFirebaseSessionHOC from "../../high-order-components/with-active-firebase-session";
import ScanInProgress from "../scan-in-progress/Main";
import StudioLayout from "../insole-studio/StudioLayout";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={AppHandoffRoute} element={<AppHandoff />} />
      <Route
        element={
          <WithActiveFirebaseSessionHOC>
            <StudioLayout />
          </WithActiveFirebaseSessionHOC>
        }
      >
        <Route path={PreviewInsoleRoute} element={<PreviewInsole />} />
        <Route path={PersonalizationRoute} element={<Personalization />} />
      </Route>
      <Route
        path={ScanInProgressRoute}
        element={
          <WithActiveFirebaseSessionHOC>
            <ScanInProgress />
          </WithActiveFirebaseSessionHOC>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
